import React from 'react';

const IconMedium = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 1770 1000"
    fill="none"
    stroke="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-codepen">
    <circle cx="500" cy="500" r="500" fill="currentColor" />
    <ellipse ry="475" rx="250" cy="501" cx="1296" fill="currentColor" />
    <ellipse cx="1682" cy="502" rx="88" ry="424" fill="currentColor" />
  </svg>
);

export default IconMedium;
